import { useState } from "react";
import { toast } from "react-toastify";
import { createDealFolder } from "../../utils/driveClient";

// Shows a spinner while the onDealCreate trigger creates the deal's Drive
// folder, alongside a manual "Create folder now" button. Clicking the
// button calls the same createDealFolder recovery callable the error
// banner uses — useful for older deals (no trigger ever ran) or deals
// whose trigger failed silently.
export default function FolderLoadingState({ dealId, onResolved }) {
  const [creating, setCreating] = useState(false);

  const handleCreate = async () => {
    if (!dealId) {
      toast.error("Can't create folder: deal id missing");
      return;
    }
    setCreating(true);
    try {
      await createDealFolder(dealId);
      toast.success("Drive folder created");
      onResolved && onResolved();
    } catch (e) {
      toast.error(`Couldn't create folder: ${e.message}`);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-12 text-gray-500 gap-3">
      <div className="text-sm">This deal doesn't have a Drive folder yet.</div>
      <button
        type="button"
        onClick={handleCreate}
        disabled={creating}
        className="px-4 py-2 bg-blue-600 text-white rounded text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
      >
        {creating ? "Creating…" : "Create folder"}
      </button>
    </div>
  );
}
